import * as ajax from './_ajax'
import * as resources from './_resources'
import * as modal from './_modal'
import * as msg from './_msg'
import * as types from './_types'

export module login {
    export interface ILogInArguments {
        email?: string
        password?: string
        captcha?: string
        code?: string
        onComplete?: any
        onFail?: any
        onError?: any
    }

    export interface ILogInAjaxReply {
        Modal?: boolean
        Result: types.object.IJsonResult
        Account: types.object.IOrganizationAccount
        Jwt?: string
        Domain?: string
    }

    export function doLogIn(args: ILogInArguments): void {
        ajax.post({
            loadingText: 'Loggar in...',
            url: resources.url.account.logIn,
            data: {
                email: args.email,
                password: args.password,
                captcha: args.captcha,
            },
            success: function (res: ILogInAjaxReply) {
                if (res.Result.Ok) {
                    if (res.Jwt && res.Domain) {
                        location.href = `https://${res.Domain}/account/login?code=${res.Jwt}`
                        return
                    }

                    if (args.onComplete) args.onComplete(res)
                } else {
                    if (res.Modal) {
                        modal.show(res.Result.Message)
                    } else {
                        msg.showError(res.Result.Message)
                    }
                    if (args.onFail) args.onFail(res)
                }
            },
            error: function (xhr, textStatus, errorThrown) {
                msg.showError(textStatus)
                if (args.onError) args.onError(xhr, textStatus, errorThrown)
            },
        })
    }

    export function doLogInUsingToken(args: ILogInArguments): void {
        ajax.post({
            loadingText: 'Loggar in...',
            url: resources.url.account.loginUsingToken,
            data: {
                code: args.code,
            },
            success: function (res: ILogInAjaxReply) {
                if (res.Result.Ok) {
                    if (args.onComplete) args.onComplete(res)
                } else {
                    if (res.Modal) {
                        modal.show(res.Result.Message)
                    } else {
                        msg.showError(res.Result.Message)
                    }
                    if (args.onFail) args.onFail(res)
                }
            },
            error: function (xhr, textStatus, errorThrown) {
                msg.showError(textStatus)
                if (args.onError) args.onError(xhr, textStatus, errorThrown)
            },
        })
    }
}
